<div class="cart-item-group" *ngIf="cartItemGroup">
	<div class="group-icon">
		<div class="icon">
			<img [src]="cartItemGroup.groupIcon" />
		</div>
	</div>

	<div class="group-details">
		<div class="group-header" *ngIf="cartItemGroup.header">
			<div
				class="header-name"
				[innerHTML]="cartItemGroup.header.name"
				*ngIf="cartItemGroup.header.name"
			></div>

			<div class="header-values" *ngIf="!nbnflow">
				<span
					class="header-initial-value"
					*ngIf="cartItemGroup.header.initialValue"
					[innerHTML]="cartItemGroup.header.initialValue"
				></span>
				<span
					class="header-final-value"
					*ngIf="cartItemGroup.header.finalValue"
					[innerHTML]="cartItemGroup.header.finalValue"
				></span>

				<span
					class="header-value-text"
					*ngIf="cartItemGroup.header.valueText"
					[innerHTML]="cartItemGroup.header.valueText"
				></span>
			</div>
		</div>

		<div
			class="detail-item"
			*ngFor="let cartItemGroupDetails of cartItemGroup.details"
		>
			<div
				class="detail-name"
				[innerHTML]="cartItemGroupDetails.name"
				*ngIf="cartItemGroupDetails.name"
			></div>

			<div class="detail-values">
				<span
					class="detail-initial-value"
					*ngIf="cartItemGroupDetails.initialValue"
					[innerHTML]="cartItemGroupDetails.initialValue"
				></span>
				<span
					class="detail-final-value"
					*ngIf="cartItemGroupDetails.finalValue"
					[innerHTML]="cartItemGroupDetails.finalValue"
				></span>

				<span
					class="detail-value-text"
					*ngIf="cartItemGroupDetails.valueText"
					[innerHTML]="cartItemGroupDetails.valueText"
				></span>
			</div>
		</div>
	</div>
</div>
